// DON't CHANGE!
// automated by SVGR script
import * as React from "react";
const SecurityCardIcon = props => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24",
  "aria-hidden": "true",
  "data-icon": "SecurityCard/outline"
}, props), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M11.74 17.75h5.92c-.09.08-.18.15-.27.23l-4.27 3.2c-1.41 1.05-3.71 1.05-5.13 0l-4.28-3.2C2.77 17.28 2 15.73 2 14.56V7.15c0-1.22.93-2.57 2.07-3l4.98-1.87c.82-.31 2.18-.31 3 0l4.97 1.87c.95.36 1.76 1.36 2.01 2.38h-7.3c-.22 0-.42.01-.61.01-1.85.11-2.33.78-2.33 2.89v5.43c.01 2.3.6 2.89 2.95 2.89Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M8.8 11.22H22"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M22 9.42v5.55c-.02 2.22-.63 2.77-2.94 2.77h-7.32c-2.35 0-2.94-.59-2.94-2.9V9.41c0-2.1.48-2.77 2.33-2.89.19 0 .39-.01.61-.01h7.32c2.35.01 2.94.59 2.94 2.91Z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.5,
  d: "M11.32 15.26h1.33M14.75 15.26h3.27"
}));
export default SecurityCardIcon;